window.addEventListener("load", function () {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            Accept: "application/json",
        },
    });
});

window.ajaxCall = function (
    url,
    formData,
    successCallback = (data) => {},
    errorCallback = (key, value) => {},
    enableLoadingIndicator = false
) {
    if (enableLoadingIndicator) {
        $(".ajax-indicator-button").prop("disabled", true);
        $(".ajax-indicator-button").addClass("disabled");
        $(".ajax-indicator-button > i").removeClass("d-none");
    }

    $.ajax({
        type: "POST",
        url: url,
        data: formData,
        success: function (data) {
            if (enableLoadingIndicator) {
                $(".ajax-indicator-button").prop("disabled", false);
                $(".ajax-indicator-button").removeClass("disabled");
                $(".ajax-indicator-button > i").addClass("d-none");
            }

            successCallback(data);
        },
        error: function (data) {
            if (enableLoadingIndicator) {
                $(".ajax-indicator-button").prop("disabled", false);
                $(".ajax-indicator-button").removeClass("disabled");
                $(".ajax-indicator-button > i").addClass("d-none");
            }

            if (data.status == 422) {
                let errors = data.responseJSON.errors;
                for (let key in errors) {
                    let value = errors[key];

                    errorCallback(key, value);
                }
            } else if (data.status == 400) {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: data.responseJSON.message,
                    showConfirmButton: false,
                });
            } else if (data.status == 403) {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Ehhez a művelethez nincs jogosultságod!",
                    showConfirmButton: false,
                });
            } else if (data.status == 419) {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Az oldal élettartama lejárt!",
                    text: "Kérjük töltsd újra az oldalt, majd ismételd meg a műveletet!",
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Váratlan hiba történt!",
                    showConfirmButton: false,
                });
            }
        },
    });
};
